import { cleanNumber } from "./NumberUtil";

export function localToString(s) {
  if (!s) {
    return "";
  }
  return String(s);
}

export function cleanString(s) {
  if (!s) {
    return "";
  }
  return String(s).trim();
}

export function parseJwt(token) {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export function removeSpecialChars(string) {
  if (!string) {
    return string;
  }
  return `${string}`.replace(/[^a-zA-Z0-9 ]/g, "");
}

export function formatCedula(doc) {
  const cleanNumber = `${doc}`.replace(/\D/g, "");

  const len = cleanNumber?.length;
  let result = "";

  if (len >= 3) {
    result += `${cleanNumber?.slice(0, 3)}-`;
  }

  if (len >= 11) {
    result += `${cleanNumber?.slice(3, 10)}-`;
  }

  result += cleanNumber?.slice(10);

  return result;
}

export function formatPhoneNumber(phoneNumberString) {
  if (!phoneNumberString) {
    return null;
  }

  const numberClean = cleanNumber(phoneNumberString);

  const len = numberClean?.length;
  let result = `(${numberClean}`;

  if (len < 3) {
    return result;
  }
  result = `(${numberClean?.slice(0, 3)}) ${numberClean?.slice(3)}`;

  if (len < 6) {
    return result;
  }
  result = `(${numberClean?.slice(0, 3)}) ${numberClean?.slice(
    3,
    6
  )}-${numberClean?.slice(6)}`;

  return result;
}

export const isEmptyValue = (dato) => {
  return (
    !dato ||
    (typeof dato === "object" && Object.keys(dato).length === 0) ||
    (typeof dato === "string" && dato.trim().length === 0)
  );
};

export function removeLineBreaks(cadena) {
  return cadena?.replace(/\r?\n|\r/g, "");
}